"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorPage = void 0;
var react_1 = __importStar(require("react"));
/* Imported CSS */
require("./ErrorPage.scss");
/* Blast Imports */
var YellowButton_1 = require("@app/components/controls/YellowButton");
var Page_1 = require("@app/components/layout/Page");
var constants_1 = require("@app/shared/constants");
var goBack = function (prevPath, history, jwt) {
    // Ignore history, either go to the home or login page, based on if the user is logged in
    if (jwt) {
        history.push('/dash');
    }
    else {
        history.push('/login');
    }
};
var ErrorPage = /** @class */ (function (_super) {
    __extends(ErrorPage, _super);
    function ErrorPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ErrorPage.prototype.render = function () {
        var _this = this;
        var epState = this.props.location.state; // Error Page location state
        var jwt = sessionStorage.getItem(constants_1.JWT_STORAGE_KEY);
        var type = this.props.match.params.type;
        var buttonText = jwt ? 'Go to your inbox' : 'Go to login';
        var errorMessage;
        if (type === constants_1.EMAIL_MISMATCH) {
            errorMessage = 'You are attempting to access a package that was intended for someone else.';
        }
        else {
            errorMessage = "It seems like you've reached this page by accident. Sorry for the inconvenience, click the button below to return to your homepage.";
        }
        return (react_1.default.createElement(Page_1.Page, { title: "Not Found" },
            react_1.default.createElement("div", { className: "columns" },
                react_1.default.createElement("div", { className: "column is-half is-offset-one-quarter not-found-view" },
                    react_1.default.createElement("h2", { className: "subtitle" }, errorMessage),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(YellowButton_1.YellowButton, { type: "button", className: "button-large", "data-test": "back-button", onClick: function () { return goBack((epState ? epState.prevPath : ''), _this.props.history, jwt); } },
                            react_1.default.createElement("span", { className: "icon" },
                                react_1.default.createElement("i", { className: "fas fa-chevron-left" })),
                            react_1.default.createElement("span", null, buttonText)))))));
    };
    return ErrorPage;
}(react_1.Component));
exports.ErrorPage = ErrorPage;
